import useProfiler from "../../../hooks/useProfiler";
import { createTrackingUtils } from "..";
import { useCallback } from "react";
import { flightsSessionStore } from "@flights/web-api-utils-universal";

const utils = createTrackingUtils({
  name: "flights_alternative_fares_for_price_change_and_sold_out_errors_web",
  defaultStage: 3,
  stages: {
    verify_price_change_price_change: 1,
    finalize_price_change_sold_out: 2,
    main: 3, // Both stage 1 and 2 combined
    desktop: 4, // Main - Desktop
    mobile: 5 // Main - Mobile
  },
  goals: {
    alt_fares_failed_load: 1,
    click_select_on_alt_fares: 2,
    attempt_pay_on_suggested_fare: 3
  }
});

export const useTrackMainAlternativeFaresStage = () => {
  const { isDesktop, isMobile } = useProfiler();

  return useCallback(() => {
    isDesktop() && utils.stages.desktop();
    isMobile() && utils.stages.mobile();

    return utils.trackWithDefaultStage();
  }, [isDesktop, isMobile]);
};

const key = "alternative_fare_selected";

export const useTrackSelectedAlternativeFare = () => {
  const setSelectedAlternativeFare = useCallback((flightToken: string) => {
    flightsSessionStore.set(key, flightToken);
  }, []);

  const isPaymentForSavedAlternativeFare = useCallback((flightToken: string) => {
    const savedFare = flightsSessionStore.get(key) as string | undefined;

    return savedFare === flightToken;
  }, []);

  return { setSelectedAlternativeFare, isPaymentForSavedAlternativeFare };
};

export default utils;
